<!--
 * @Author: your name
 * @Date: 2021-01-05 11:14:22
 * @LastEditTime: 2021-01-06 10:50:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\email\index.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">校园意见箱</router-link>
        &gt; 其他栏目 &gt; 通知公告
      </div>
    </div>
    <div class="z_title1" style="margin-top: 10px">通知公告</div>
    <div class="itemsList" v-for="(item, index) in list" :key="index">
      <div style="display: flex; align-items: center">
        <img
            style="margin-right: 5px"
            src="@/assets/point.jpg"
            width="4"
            height="4"
            alt=""
        />
        <router-link target="_blank" class="STYLE1"
                     :to="{path: '/message/info',query: { record: encodeURIComponent(JSON.stringify(item)) }}">
          {{ item.name }}
        </router-link>
      </div>
      <div align="left" class="STYLE1">
        {{ item.lostTime ? item.lostTime : "2017-1-1" }}
      </div>
    </div>
    <a-pagination
        @change="pageChange"
        :current="current"
        style="margin-top: 10px"
        size="small"
        :total="total"
        :pageSize="pageSize"
    />
  </div>
</template>

<script>
import {getAction, postAction} from "@/api/manage";

export default {
  data() {
    return {
      list: [],
      total: 1,
      current: 1,
      pageSize: 15,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    pageChange(page) {
      this.current = page;
      this.getList();
    },
    getList() {
      postAction("/sys/notice/list", {
        pageSize: this.pageSize,
        pageNum: this.current,
      }).then((data) => {
        this.list = data.data.list;
        this.total = data.data.total;
      });
    },
  },
};
</script>

<style scoped>
.itemsList {
  margin-top: 20px;
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
